// extracted by mini-css-extract-plugin
export default {"columns21":"TeamForm_columns21__0tUtT","columns11":"TeamForm_columns11__2jGJk","title":"TeamForm_title__AGo11"};